<template>
  <!-- 眼科学员登录layout -->
  <div class="user-layout-wrapper content-bg-color">
    <!-- header -->
    <div class="header-wrap">
      <img src="~@/assets/logo-layout-eye.png" alt="logo" class="logo" />
      <div class="title">国家基层儿童青少年近视防控人员培训管理系统</div>
    </div>
    <!-- view -->
    <div class="user-view"><router-view></router-view></div>
    <!-- footer -->
    <div class="footer-wrap">
      <!-- content -->
      <div class="footer-content">
        <div class="qr-code">
          <div class="code">
            <img
              src="~@/assets/eye/wechat-code.png"
              alt="qrcode"
              width="55"
              height="55"
            />
            <div class="tip">明眸学苑</div>
          </div>
          <div class="code">
            <img
              src="~@/assets/user_layout/login-code.jpg"
              alt="qrcode"
              width="55"
              height="55"
            />
            <div class="tip">技术支持</div>
          </div>
        </div>
        <div class="content-wrap">
          <div class="item-wrap">
            <div class="item-block">
              <div class="item">
                <span>主办单位: </span>
                <span>中华医学会（待审批）</span>
              </div>
              <div class="item">
                <span>协办单位: </span>
                <span>中华医学会眼科分会</span>
              </div>
              <div class="item">
                <span>实施单位: </span>
                <span
                  >上海市第一人民医院 上海市眼病防治中心 上海医疗质量研究中心
                  上海市视觉健康中心（儿童青少年近视防治技术中心）</span
                >
              </div>
            </div>
            <div class="item-block">
              <div class="flex-wrap">
                <div style="margin-right:10px;">
                  <div class="item">
                    <span>技术支持: </span>
                    <span>上海源墨健康管理有限公司</span>
                  </div>
                  <div class="item">
                    <span></span>
                    <a href="https://beian.miit.gov.cn"
                      >沪ICP备2020032025号-2</a
                    >
                  </div>
                </div>
                <div class="flex-center">
                  <img
                    src="~@/assets/eye/footer-logo.png"
                    style="max-width:100%;width:375px;"
                  />
                </div>
              </div>
              <div class="item">
                <span
                  >为了更好的网站体验，建议您使用谷歌、火狐、IE9及以上版本、360极速模式等高版本的浏览器</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserLayout"
};
</script>

<style lang="less" scoped>
.user-layout-wrapper {
  min-height: 100%;
  // background-image: url(~@/assets/background.svg);
  // background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .header-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 66px;

    .logo {
      width: 200px;
      height: 200px;
    }

    .title {
      font-size: 30px;
      font-weight: 700;
      // color: rgba(0, 0, 0, 0.85);
      color: @primary-color;
      margin: 12px 0 36px 0;
    }
  }

  @media screen and (max-width: 1440px) {
    .header-wrap {
      padding-top: 36px;
      .logo {
        width: 100px;
        height: 100px;
      }
    }
  }

  .user-view {
    flex-grow: 1;
  }

  .footer-wrap {
    .footer-content {
      background: @primary-color; //rgba(0, 33, 64, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px 0;
      .qr-code {
        height: 100%;
        align-items: center;
        display: flex;
        width: 170px;
        padding: 0 20px;
        justify-content: space-between;
        .code {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .tip {
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            letter-spacing: 1px;
            text-align: center;
          }
        }
      }
      .content-wrap {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 1px;
        display: flex;
        flex-direction: column;
        .item-wrap {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
        }
        .item-block {
          padding: 6px 20px;
          .item {
            padding: 4px 0;
            a {
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
    }
    .footer-imgs {
      max-width: 868px;
      margin: 0 auto;
      padding: 10px 0;
      /deep/ .ant-col {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
      }
    }
  }
}
</style>
